import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { I18n } from 'react-redux-i18n'
import Grid from 'material-ui/Grid'
import TextField from 'material-ui/TextField'
import MenuItem from 'material-ui/Menu/MenuItem'
import _ from 'lodash'

import calcImageUrl from 'assets/images/calc.svg'
import calculator from 'modules/calculator'
import parametersSelector from 'selectors/parameters'
import calculatorSelector from 'selectors/calculator'
import { currency_icon } from 'core/utils'

const { calculateCoinAmount, calculateCoinPrice, calculateToggleDirection, setCode } = calculator(
  'dashboard'
)

const Calculator = ({
  calculateCoinAmount,
  calculateCoinPrice,
  calculateToggleDirection,
  setCode,
  config_parameters,
  available_currencies,
  calculator
}) =>
  available_currencies && (
    <div>
      <div>
        <h3>{I18n.t('main.step.calc_block.h')}</h3>
      </div>
      <div className="up">
        <Grid container>
          <Grid item md={5} xs={12}>
            <TextField
              type="text"
              className="form-control-mui"
              value={calculator.coin_amount}
              helperText={config_parameters['coin.tiker']}
              disabled={calculator.direction === 'left'}
              onChange={e => calculateCoinAmount(e.target.value)}
              margin="normal"
              autoComplete="off"
            />
          </Grid>
          <Grid item md={2} xs={12} className="direction">
            <img
              src={calcImageUrl}
              alt=""
              onClick={() => calculator.loading || calculateToggleDirection()}
            />
          </Grid>
          <Grid item md={5} xs={12}>
            <div className="form-group">
              <TextField
                type="text"
                id="coin-price"
                className="form-control-mui"
                value={calculator.coin_price}
                disabled={calculator.direction === 'right'}
                onChange={e => {
                  calculateCoinPrice(e.target.value)
                }}
                autoComplete="off"
                margin="normal"
              />

              <div className="list-currency">
                <TextField
                  id="calculator-currency-btn"
                  select
                  className="form-control-mui current-currency list-currency-icon"
                  value={calculator.code}
                  onChange={e => setCode(e.target.value)}
                  margin="normal"
                  fullWidth
                >
                  {_.map(available_currencies, (currency, currency_code) => (
                    <MenuItem
                      key={currency_code}
                      value={currency_code}
                      className="list-currency-icon"
                    >
                      {currency_icon(currency_code, 'currency-select-bg')}
                      {currency.name}
                    </MenuItem>
                  ))}
                </TextField>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
      <div className="down">
        <Grid container>
          <Grid item md={6} xs={12}>
            <span>
              {I18n.t('calculator.bonus', { bonus_percent: I18n.l(calculator.bonus_percent) })}
            </span>
            <div>{I18n.l(calculator.coin_bonus)}</div>
          </Grid>
          <Grid item md={6} xs={12}>
            <span>{I18n.t('calculator.total')}</span>
            <div>{I18n.l(calculator.coin_total)}</div>
          </Grid>
        </Grid>
      </div>
    </div>
  )

class CalculatorContainer extends Component {
  componentDidMount() {
    const { calculateCoinAmount, config_parameters } = this.props
    const min_coin_for_payment = config_parameters['coin.min_payment_coins_amount'] || 1
    calculateCoinAmount(min_coin_for_payment)
  }

  render() {
    return <Calculator {...this.props} />
  }
}

const mapStateToProps = state => ({
  config_parameters: parametersSelector(state),
  available_currencies: parametersSelector(state).available_currencies,
  calculator: calculatorSelector('dashboard')(state)
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      calculateCoinAmount,
      calculateCoinPrice,
      calculateToggleDirection,
      setCode
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(CalculatorContainer)



// WEBPACK FOOTER //
// ./src/containers/pages/dashboard/calculator.js